/*
 * Copyright (c) 2024. Devtron Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { URLS } from '../../config'
import { updatePostHogEvent } from '../../services/service'

export const POSTHOG_EVENT_ONBOARDING = {
    PREVIEW: 'Preview',
    DEPLOY_CUSTOM_APP_CI_CD: 'Deploy custom app using CI/CD pipelines',
    INSTALL_CUSTOM_CI_CD: 'Install CI/CD',
    VIEW_APPLICATION: 'View helm application',
    BROWSE_HELM_CHART: 'Browse helm chart',
    CONNECT_CLUSTER: 'Connect cluster',
    CONNECT_CHART_REPOSITORY: 'Connect chart repository',
    TOOLTIP_OKAY: 'Tooltip okay',
    TOOLTIP_DONT_SHOW_AGAIN: 'Tooltip Dont show again',
    HELP: 'Clicked Help',
    SKIP_AND_EXPLORE_DEVTRON: 'SkippedOnboarding',
}

export const LOGIN_COUNT = 'login-count'

export const MAX_LOGIN_COUNT = 5

export const handlePostHogEventUpdate = (e, eventName?: string): void => {
    const payload = {
        eventType: eventName || e.target?.dataset.posthog,
        key: LOGIN_COUNT,
        value: '',
        active: true,
    }
    updatePostHogEvent(payload)
}

export const NAVIGATION = {
    AUTOCOMPLETE: `${URLS.APP}/${URLS.APP_LIST}/${URLS.APP_LIST_HELM}?hOffset=0&namespace=1&offset=0`,
    HELM_APPS: `${URLS.APP}/${URLS.APP_LIST}/${URLS.APP_LIST_HELM}`,
}
